import { render, staticRenderFns } from "./new-order-table.component.vue?vue&type=template&id=6c52798f&scoped=true"
import script from "./new-order-table.component.vue?vue&type=script&lang=js"
export * from "./new-order-table.component.vue?vue&type=script&lang=js"
import style0 from "./new-order-table.component.vue?vue&type=style&index=0&id=6c52798f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c52798f",
  null
  
)

export default component.exports